import { fetchWithAuth } from "./fetchWithAuth";

export async function openProtectedFile(fileUrl, fileName = "document.pdf") {
  const targetWindow = window.open("about:blank", "_blank");
  if (targetWindow) {
    targetWindow.opener = null;
  }

  try {
    const res = await fetchWithAuth(fileUrl);

    if (!res.ok) {
      const responseError = await res.json().catch(() => null);
      throw new Error(responseError?.error || "Failed to open document");
    }

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);

    if (targetWindow) {
      targetWindow.location.href = blobUrl;
      targetWindow.document.title = fileName;
      window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    } else {
      window.location.href = blobUrl;
    }
  } catch (err) {
    if (targetWindow) {
      targetWindow.close();
    }

    alert(err.message);
  }
}
